module.exports = __webpack_public_path__ + "static/img/OPEL.41e62e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/OPEL.png
// module id = WLd5
// module chunks = 1